import React, { useState } from "react";
import OrdersRow from "../OrdersRow/index";
import { Accordion, Form, Row, Col, Button } from "react-bootstrap";
import { filterByOrderStatusDropdown } from "../../../../components/helper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate } from "../../../../helper";
import ReactPaginate from "react-paginate";
var Scroll = require("react-scroll");

export default function Orders(props) {
  const { orders, fetchOrders, ordersCount, setOrders } = props;
  const [orderStatus, setOrderStatus] = useState(null);
  const [order_id, setOrderId] = useState(null);
  const [given_name, setGivenName] = useState(null);
  const [username, setUsername] = useState(null);
  const [startDate, setStartDate] = useState(null);

  const addNewOrder = () => {
    const newOrders = Object.assign([], orders);
    newOrders.push({
      user_attributes: { email: null, username: null, given_name: null },
      address: null,
      products: [],
    });
    setOrders(newOrders);
    Scroll.animateScroll.scrollToBottom();
  };

  const deleteEmptyOrder = () => {
    const newOrders = Object.assign([], orders);
    newOrders.pop();
    setOrders(newOrders);
  };

  return (
    <div>
      <h2 className="pt-3 pl-3 pb-3">Orders</h2>
      <div className="mb-4 d-flex justify-content-around">
        {filterByOrderStatusDropdown(orderStatus, async (element) => {
          setOrderStatus(element);
          await fetchOrders({
            orderStatus: element,
            order_id,
            given_name,
            username,
            date: startDate ? formatDate(startDate) : null,
            pageNo: 1,
          });
        })}
        <div>
          Filter By Date:
          <DatePicker
            selected={startDate}
            onChange={async (date) => {
              setStartDate(date);
              await fetchOrders({
                orderStatus,
                order_id,
                given_name,
                username,
                date: date ? formatDate(date) : null,
                pageNo: 1,
              });
            }}
            dateFormat="yyyy/MM/dd"
          />
        </div>
      </div>

      <div>
        <Form.Group className="mx-auto w-75">
          <Form.Control
            value={order_id || ""}
            onChange={async (event) => {
              const {
                target: { value },
              } = event;
              setOrderId(value === "" ? null : value);
              await fetchOrders({
                orderStatus,
                order_id: value,
                given_name,
                username,
                date: startDate ? formatDate(startDate) : null,
                pageNo: 1,
              });
            }}
            placeholder="Search By Order Id"
            type="text"
          />
        </Form.Group>
        <Form.Group className="mx-auto w-75">
          <Form.Control
            value={given_name || ""}
            onChange={async (event) => {
              const {
                target: { value },
              } = event;
              setGivenName(value === "" ? null : value);
              await fetchOrders({
                orderStatus,
                order_id,
                given_name: value,
                username,
                date: startDate ? formatDate(startDate) : null,
                pageNo: 1,
              });
            }}
            placeholder="Search By Customer Name"
            type="text"
          />
        </Form.Group>
        <Form.Group className="mx-auto w-75">
          <Form.Control
            value={username || ""}
            onChange={async (event) => {
              const {
                target: { value },
              } = event;
              setUsername(value === "" ? null : value);
              await fetchOrders({
                orderStatus,
                order_id,
                given_name,
                username: value,
                date: startDate ? formatDate(startDate) : null,
                pageNo: 1,
              });
            }}
            placeholder="Search By Phone Number"
            type="text"
          />
        </Form.Group>
      </div>
      <Button onClick={addNewOrder} className="mb-2 ml-2">
        Create New Order
      </Button>
      <Row>
        <Col>Order Id</Col>
        <Col>Create Date</Col>
        <Col>Name</Col>
        <Col>Contact/Username</Col>
        <Col>Delivery Type</Col>
        <Col>Status</Col>
        <Col>Amount</Col>
        <Col>Payment Method</Col>
      </Row>
      {orders && orders.length > 0 ? (
        <Accordion>
          {orders.map((element, index) => (
            <OrdersRow
              order={element}
              index={index}
              deleteEmptyOrder={deleteEmptyOrder}
              fetchOrders={fetchOrders}
            />
          ))}
        </Accordion>
      ) : (
        <h2 className="text-center">No orders placed</h2>
      )}
      <div className="d-flex justify-content-center mt-5">
        <ReactPaginate
          previousLabel={"previous"}
          nextLabel={"next"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={ordersCount / 20}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={async (data) => {
            await fetchOrders({
              orderStatus,
              order_id,
              given_name,
              username,
              date: startDate ? formatDate(startDate) : null,
              pageNo: data.selected + 1,
            });
          }}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
        />
      </div>
    </div>
  );
}
